import React from "react"
import Connect from "../base-pages/connect"

const ConnectEN = () => {
  return <Connect lang="en" />
}

export default ConnectEN
